import { styled } from '@mui/material/styles';
import axiosServices from '../utils/axios';
import { Button } from '@mui/material';
import { dispatch } from 'store';
import { openSnackbar } from 'store/reducers/snackbar';
import useAuth from '../hooks/useAuth';
import { isAdmin } from '../utils/route-guard/roles-check';

const ClearCacheButtonContainer = styled('div')(({ theme }) => ({
    position: 'relative',
    top: 16,
    display: 'inline-block',
}));

const clearCache = () => {
    axiosServices
        .delete(`cache`)
        .then(() =>
            dispatch(
                openSnackbar({
                    open: true,
                    message: 'Cache cleared!',
                    variant: 'alert',
                    alert: {
                        color: 'success',
                    },
                }),
            ),
        )
        .catch(() =>
            dispatch(
                openSnackbar({
                    open: true,
                    message: 'Failed to clear the cache.',
                    variant: 'alert',
                    alert: {
                        color: 'error',
                    },
                }),
            ),
        );
};

const ClearCacheButton = () => {
    const { user } = useAuth();
    const isCurrentUserAdmin = isAdmin(user);

    if (isCurrentUserAdmin)
        return (
            <ClearCacheButtonContainer>
                <Button variant="contained" color="primary" onClick={clearCache} style={{ marginBottom: '1rem' }}>
                    Clear Cache
                </Button>
            </ClearCacheButtonContainer>
        );

    return <></>;
};

export default ClearCacheButton;
